import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warn",
  "use": "icon-warn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-warn\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0a512 512 0 1 0 512 512 512 512 0 0 0-512-512z m0 842.24a78.08 78.08 0 1 1 78.08-78.08A78.08 78.08 0 0 1 512 842.24zM581.76 576a69.76 69.76 0 0 1-139.52 0l-12.16-310.4a79.36 79.36 0 0 1 23.04-59.52 83.2 83.2 0 0 1 117.76 0 79.36 79.36 0 0 1 23.04 59.52z\" p-id=\"6285\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/warn.svg
// module id = a5SC
// module chunks = 40